module.exports = __webpack_public_path__ + "common/icon-cart-white-2145c4ce5e70c67aa8be23fe2c0c9929.svg";